module.exports = __webpack_public_path__ + "img/img3.0550d5ad.svg";